import { Injectable, OnDestroy, TemplateRef } from '@angular/core';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AppService } from './app.service';
import { Application, ApplicationData, AppVersion } from '../../interfaces/application';

@Injectable()
export class AppManagementStateService implements OnDestroy {
  private appsSubject = new BehaviorSubject<ApplicationData[] | null>(null);
  private appsWithVersionsSubject = new BehaviorSubject<AppVersion[] | null>(null);
  private destroy$ = new Subject<void>();

  apps$: Observable<ApplicationData[]> = this.appsSubject.pipe(
    filter((apps): apps is ApplicationData[] => apps !== null)
  );
  appsWithVersions$: Observable<AppVersion[]> = this.appsWithVersionsSubject.pipe(
    filter((apps): apps is AppVersion[] => apps !== null)
  );

  constructor(private appService: AppService) {
    this.load();
  }

  load(): void {
    this.appService
      .getAllApplications()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (apps) => {
          this.appsSubject.next(apps);
          this.appsWithVersionsSubject.next(
            apps.flatMap((app) => {
              return app.versions.map((version) => {
                return {
                  // from Application
                  appId: app.appId,
                  name: app.name,
                  description: app.description,
                  // from Version
                  appVersionId: version.appVersionId,
                  version: version.version,
                  containerName: version.containerName,
                  inputs: version.inputs,
                  releaseDate: version.releaseDate,
                  isArchived: version.isArchived,
                  archivedAt: version.archivedAt,
                  orgs: version.orgs,
                };
              });
            })
          );
        },
      });
  }

  refresh(): void {
    this.load();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
